export const MAX_SELECTED_VALUES_IN_CONDITIONS = 1000;
